/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiTransactionDirection {
    INCOMING = 'INCOMING',
    OUTGOING = 'OUTGOING'
}


export function instanceOfInternalApiTransactionDirection(value: any): boolean {
    for (const key in InternalApiTransactionDirection) {
        if (Object.prototype.hasOwnProperty.call(InternalApiTransactionDirection, key)) {
            if (InternalApiTransactionDirection[key as keyof typeof InternalApiTransactionDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiTransactionDirectionFromJSON(json: any): InternalApiTransactionDirection {
    return InternalApiTransactionDirectionFromJSONTyped(json, false);
}

export function InternalApiTransactionDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionDirection {
    return json as InternalApiTransactionDirection;
}

export function InternalApiTransactionDirectionToJSON(value?: InternalApiTransactionDirection | null): any {
    return value as any;
}

export function InternalApiTransactionDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiTransactionDirection {
    return value as InternalApiTransactionDirection;
}

